import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'

const copy = {
  heading: `Thank you for completing the Customer Data Maturity evaluation`,
  description: `We’ve sent a copy of the results below to your email.`,
}

const HeroResult = () => (
  <Wrapper>
    <HeroComponent variant="centered">
      <HeroRecipe.Copy>
        <CopyTextBase centered={true}>
          <CopyText.Heading variant="h4" tag="h1">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description variant="pMedium">{copy.description}</CopyText.Description>
        </CopyTextBase>
      </HeroRecipe.Copy>
    </HeroComponent>
  </Wrapper>
)

const Wrapper = styled.header``

const HeroComponent = styled(HeroBase)`
  ${HeroRecipe.Wrapper} {
    gap: 0;
    padding-bottom: 20px;
  }
`

export default HeroResult
